import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var generateStyle = function generateStyle(componentTheme) {
  var sectionStyle = {
    display: 'flex',
    alignItems: 'center'
  };
  return {
    leftFooter: {
      display: 'inline-flex',
      flexWrap: 'nowrap',
      alignItems: 'center'
    },
    pointsSection: sectionStyle,
    feedbackSection: _objectSpread(_objectSpread({}, sectionStyle), {}, {
      marginLeft: componentTheme.feedbackSectionLeftMarg
    }),
    pointsInput: {
      width: '6.1rem' /* wide enough to fit 3 decimal places (i.e. 8.888) */,
      fontSize: componentTheme.pointsInputFontSize,
      display: 'inline-flex'
    }
  };
};
export default generateStyle;